import { GEGSystemType } from '@nx-customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const GEGSystemTypeToPhraseKey: EnumDictionary<GEGSystemType, string> = {
    [GEGSystemType.New]: 'GEG_SYSTEM_CHOICE.SYSTEM.SYSTEM_TYPE.NEW',
    [GEGSystemType.Current]: 'GEG_SYSTEM_CHOICE.SYSTEM.SYSTEM_TYPE.CURRENT',
    [GEGSystemType.Hybrid]: 'GEG_SYSTEM_CHOICE.SYSTEM.SYSTEM_TYPE.HYBRID'
};
